import { z } from 'zod';
import {
    type NodeSocketCfg,
    baseNodeCfgSchema,
} from './base-node';
import type { NodeCfg } from '../nodes';

export const previousTabNodeCfgSchema = baseNodeCfgSchema.extend({
    kind: z.literal('previousTab'),
    controlValues: z.object({
        tabGroupId: z.string(),
    }),
});
export type PreviousTabNodeCfgSchema = z.infer<typeof previousTabNodeCfgSchema>;

export const previousTabNodeSocketCfg = {
    controlSockets: {
        outputs: () => ({ next: 'event' }),
        inputs: () => ({ trigger: 'event' }),
    },
    dataSockets: {
        inputs: (_cfg: NodeCfg<'previousTab'>) => ({}),
        outputs: (_cfg: NodeCfg<'previousTab'>) => {
            const ret: Record<'activeTabIndex', 'number'> = {
                activeTabIndex: 'number',
            };
            return ret;
        },
    },
} satisfies NodeSocketCfg<PreviousTabNodeCfgSchema>;
